<template>
  <div
    id="SideBar"
    class="hidden absolute top-0 right-0 left-0 bottom-0 outline-0"
  >
    <div
      @click="closeMenu()"
      class="overlay z-30 w-full h-full bg-black-full"
    ></div>
    <div
      id="sideContent"
      class="
        absolute
        z-30
        top-0
        w-full
        md:w-87
        h-full
        bg-white
        pt-18
        md:pt-13
        duration-300
        ease-in
        right-0
      "
      :key="$store.getters.uuidShoppingCartComponent"
    >
      <div class="uppercase py-4 mb-4 bg-yellow-photo font-semibold">
        <div class="font-bold px-4">{{ $t("cart.check_order") }}</div>
        <div
          @click="closeMenu()"
          class="absolute right-0 top-1 p-2 cursor-pointer"
        >
          <span class="close material-icons"> close </span>
        </div>
      </div>

      <div class="shoppingCart" v-if="$store.state.payment.Amount">
        <div
          class="item border-t border-yellow-photo"
          v-for="(item, index) in $store.state.shoppingCart"
          :key="index"
        >
          <!-- Video Sale -->
          <div class="flex mx-2 px-2 py-3 relative" v-if="item.type == 3">
            <img
              :src="
                'https://photo-public.s3.amazonaws.com/suf/logos/min/parque-' +
                item.VideoDetails.parkId +
                '.png'
              "
              :alt="item.VideoDetails.parkId"
              class="w-1/5"
            />
            <div class="flex flex-col flex-auto justify-center px-2">
              <span class="font-bold uppercase mb-1">
                {{ item.Name }}
              </span>
              <div class="flex text-xs">
                <div class="flex flex-col flex-auto">
                  <span> {{ $t("gallery.tag") }} {{ item.Tag }} </span>
                  <span>
                    {{ $tc("messages.videos", item.TotalMedia) }}
                  </span>
                  <span class="dateString">
                    {{ dateString(item.date) }}
                  </span>
                </div>
                <span class="flex font-semibold items-end">
                  {{ item.Amount | toCurrency }}
                  {{ $store.state.Currency }}
                </span>
              </div>
            </div>
            <div
              @click.prevent="
                $store.dispatch('removeParkFromShoppingCart', index)
              "
              class="
                flex
                absolute
                right-0
                top-0
                p-2
                cursor-pointer
                items-center
              "
            >
              <span class="material-icons"> delete </span>
            </div>
          </div>

          <!-- Codigos de Descarga -->
          <template v-else-if="item.type == 0">
            <div class="flex px-4 text-sm mt-2">
              <span class="font-bold mr-1">{{ $t("gallery.code") }}</span
              >{{ item.code }} |
              {{ $tc("messages.albumes", item.Parks.length) }}
            </div>

            <div
              class="flex mx-2 px-2 py-3 relative"
              v-for="(item2, idx2) in item.Parks"
              :key="idx2"
            >
              <img
                :src="
                  'https://photo-public.s3.amazonaws.com/suf/logos/min/hotel-' +
                  item2.Park.Id +
                  '.png'
                "
                class="imgCut w-1/5"
                v-if="item2.Park.IsHotel"
              />
              <img
                :src="
                  'https://photo-public.s3.amazonaws.com/suf/logos/min/parque-' +
                  item2.Park.Id +
                  '.png'
                "
                class="imgCut w-1/5"
                v-else
              />

              <div class="flex flex-col flex-auto justify-center px-2">
                <span class="font-bold uppercase mb-1"
                  >{{ $t("gallery.fotos") }}
                  {{ getParkName(item2.Park.Id) }}</span
                >
                <div class="flex text-xs">
                  <div class="flex flex-col flex-auto">
                    <span
                      >{{ item2.TotalMedia }} {{ $t("gallery.fotos") }}</span
                    >
                    <span class="dateString">{{ dateString(item.date) }}</span>
                  </div>
                  <span class="flex font-semibold items-end">
                    {{ item.NormalIndividual | toCurrency }}
                    {{ $store.state.Currency }}
                  </span>
                </div>
                <div
                  @click.prevent="
                    $store.dispatch('removeShoppingCartByDownloadCode', {
                      park: item2,
                      idx: idx2,
                      code: item.code
                    })
                  "
                  class="
                    flex
                    absolute
                    right-0
                    top-0
                    p-2
                    cursor-pointer
                    items-center
                  "
                >
                  <span class="material-icons"> delete </span>
                </div>
              </div>
              <div
                class="
                  hidden
                  flex
                  absolute
                  right-0
                  top-0
                  p-2
                  cursor-pointer
                  items-center
                "
              >
                <span class="text-xxs mr-1">{{ $t("cart.delete") }}</span>
                <svg
                  class="
                    svg-inline--fa
                    fa-trash-can
                    text-grey
                    pointer-events-none
                  "
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="trash-can"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    class=""
                    fill="currentColor"
                    d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM31.1 128H416V448C416 483.3 387.3 512 352 512H95.1C60.65 512 31.1 483.3 31.1 448V128zM111.1 208V432C111.1 440.8 119.2 448 127.1 448C136.8 448 143.1 440.8 143.1 432V208C143.1 199.2 136.8 192 127.1 192C119.2 192 111.1 199.2 111.1 208zM207.1 208V432C207.1 440.8 215.2 448 223.1 448C232.8 448 240 440.8 240 432V208C240 199.2 232.8 192 223.1 192C215.2 192 207.1 199.2 207.1 208zM304 208V432C304 440.8 311.2 448 320 448C328.8 448 336 440.8 336 432V208C336 199.2 328.8 192 320 192C311.2 192 304 199.2 304 208z"
                  ></path>
                </svg>
              </div>
            </div>
          </template>

          <!-- Room -->
          <template v-else-if="item.type == 2">
            <div class="flex px-4 text-sm mt-2">
              <span class="font-bold mr-1">{{ $t("cart.room") }}</span>
              {{ item.Room }} |
              {{ $tc("messages.albumes", item.Parks.length) }}
            </div>

            <div
              class="flex mx-2 px-2 py-3 relative"
              v-for="(item2, idx2) in item.Parks"
              :key="idx2"
            >
              <img
                :src="
                  'https://photo-public.s3.amazonaws.com/suf/logos/min/hotel-' +
                  item2.Park.Id +
                  '.png'
                "
                class="imgCut w-1/5"
                v-if="item2.Park.IsHotel"
              />
              <img
                :src="
                  'https://photo-public.s3.amazonaws.com/suf/logos/min/parque-' +
                  item2.Park.Id +
                  '.png'
                "
                class="imgCut w-1/5"
                v-else
              />

              <div class="flex flex-col flex-auto justify-center px-2">
                <span class="font-bold uppercase mb-1"
                  >{{ $t("gallery.fotos") }}
                  {{ getParkName(item2.Park.Id) }}</span
                >
                <div class="flex text-xs">
                  <div class="flex flex-col flex-auto">
                    <span
                      >{{ item2.TotalMedia }} {{ $t("gallery.fotos") }}</span
                    >
                    <span class="dateString">{{ dateString(item.date) }}</span>
                  </div>
                  <span class="flex font-semibold items-end">
                    {{ item.IsOnlyHotel ? item2.Amount : item.NormalIndividual | toCurrency }}
                    {{ $store.state.Currency }}
                  </span>
                </div>
              </div>
              <div
                @click.prevent="
                  $store.dispatch('removeShoppingCartByRoom', {
                      park: item2,
                      idx: idx2,
                      room: item.Room
                    })
                "
                class="
                  flex
                  absolute
                  right-0
                  top-0
                  p-2
                  cursor-pointer
                  items-center
                "
              >
                <span class="material-icons"> delete </span>
              </div>
            </div>
          </template>

          <!-- Regular Park -->
          <div class="flex mx-2 px-2 py-3 relative" v-else>
            <img
              :src="
                'https://photo-public.s3.amazonaws.com/suf/logos/min/parque-' +
                item.ParkID +
                '.png'
              "
              :alt="item.ParkID"
              class="w-1/5"
            />
            <div class="flex flex-col flex-auto justify-center px-2">
              <span class="font-bold uppercase mb-1" v-if="item.ServiceId != null">
                {{ item.Name }}
              </span>
              <span class="font-bold uppercase mb-1" v-else>
                {{ $t("gallery.fotos") }}
                {{ getParkName(item.ParkID) }}
              </span>

              <div class="flex text-xs">
                <div class="flex flex-col flex-auto">
                  <span v-if="item.Pax">{{ $tc("messages.pax", item.Pax) }}</span>
                  <span v-else>{{ $tc("messages.albumes", item.cantidad) }}</span>
                  <span>{{ item.TotalMedia }} {{ $t("gallery.fotos") }}</span>
                  <span class="dateString">{{ dateString(item.date) }}</span>
                </div>
                <span class="flex font-semibold items-end">
                  {{ item.Amount | toCurrency }}
                  {{ $store.state.Currency }}
                </span>
              </div>
            </div>
            
            <div
              @click.prevent="
                $store.dispatch('removeParkServiceIdFromShoppingCart', { park: item.park, tag: item.uuid })
              "
              class="
                flex
                absolute
                right-0
                top-0
                p-2
                cursor-pointer
                items-center
              "
              v-if="item.ServiceId != null"
            >
              <span class="material-icons"> delete </span>
            </div>
            <div
              @click.prevent="
                $store.dispatch('removeParkFromShoppingCart', index)
              "
              class="
                flex
                absolute
                right-0
                top-0
                p-2
                cursor-pointer
                items-center
              "
              v-else
            >
              <span class="material-icons"> delete </span>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col items-end pt-3 border-t border-yellow-photo mx-4"
        >
          <div class="flex flex-col w-4/5">
            <div class="flex text-sm hidden">
              <span class="flex-auto">Subtotal:</span>
              <span>$ 1,737.54 MXN</span>
            </div>
            <div
              class="
                flex
                font-bold
                pb-3
                mb-4
                border-b border-yellow-photo
                text-sm
              "
            >
              <span class="flex-auto">Total:</span>
              <span
                >{{ $store.state.payment.Amount | toCurrency }}
                {{ $store.state.Currency }}
              </span>
            </div>
            <div class="flex flex-auto justify-center items-center">
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="VISA"
                title="VISA"
                src="https://photo-public.s3.amazonaws.com/suf/payments/payment-methods/vi.svg"
              />
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="Mastercard"
                title="Mastercard"
                src="https://photo-public.s3.amazonaws.com/suf/payments/payment-methods/mc.svg"
              />
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="American Express"
                title="American Express"
                src="https://photo-public.s3.amazonaws.com/suf/payments/payment-methods/ax.svg"
              />
              <img
                class="paymentMethods flex flex-col flex-auto justify-center"
                alt="PayPal"
                title="PayPal"
                src="https://photo-public.s3.amazonaws.com/suf/payments/payment-methods/pp.svg"
              />
            </div>
            <p class="w-full text-xs mb-4">
              {{ $t("cart.banks_cards") }}
              <a class="text-link-blue" target="_blank" :href="$t('cart.main_cards_href')">{{ $t("cart.cards") }}</a>
            </p>
            <br />
            <a
              @click.prevent="payNow()"
              id="paymentLink"
              class="
                w-3/4
                text-center
                p-2
                bg-red-600
                text-white
                rounded-full
                text-sm
                cursor-pointer
              "
              v-if="$store.state.payment.Amount"
            >
              {{ $t("cart.pay") }}
            </a>
            <!-- <button @click="$store.dispatch('clearShoppingCart')">Limpiar carrito</button> -->
          </div>
        </div>
      </div>
      <p class="shopping-cart-empty" v-else>
        <center>
          <img
            src="https://photo-public.s3.amazonaws.com/suf/payments/shopping-cart-empty.webp"
            alt=""
          />
          <br />
          {{ $t("cart.no_products") }}
        </center>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ShoppingCartMx from "./mixins/ShoppingCart";
import CartMix from "./mixins/Cart";
import MenuMix from "./mixins/Menu";
import ShoppingCartItems from "./store/shoppingCartItemsComponent.vue";
import eventBus from "../EventBus";

export default {
  mixins: [ShoppingCartMx, CartMix, MenuMix],
  components: { ShoppingCartItems },
  data: () => ({
    uuid: "",
    renderComponent: true,
    ShoppingCart: {},
    GetShoppingCart: {},
    createdOn: Date.now() + "-" + Math.random().toString(36).substring(2, 5),
  }),
  methods: {
    updateShoppingCart() {},
    payNow() {
      this.closeMenu();
      this.$router.push({ name: "payment" });
    },
    GetPrice(item) {
      
      return new Promise((res, rej) => {
        axios
          .post("/api/payment/GetNewPrice", {
            data: {
              ServiceNumber: item.cantidad,
              ParkID: item.ParkID,
            },
          })
          .then((result) => {
            this.ShoppingCart = result.data;

            res();
          })
          .catch(() => rej());
      });
    },
    async forceRerender() {
      
      // Remove my-component from the DOM
      this.renderComponent = false;
      await this.$nextTick();
    }
  },
  watch: {},
  computed: {},
  updated() {},
  watch: {},
  created() {},
  mounted() {
    this.uuid = localStorage.getItem("uuid");
    
    this.createdOn =
      Date.now() + "-" + Math.random().toString(36).substring(2, 5);
  },
};
</script>
